import { runOnFeatureInit } from '@frontend/vanilla/core';

import { GlobalSearchBootstrapService } from './bootstrap.service';

export function provide() {
    return [runOnFeatureInit(GlobalSearchBootstrapService)];
}
